/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/wallet_medium'
export default icon
